/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserExcludingFcmMessageIdFcmTokenWithRelations } from './userExcludingFcmMessageIdFcmTokenWithRelations';


/**
 * (tsType: Omit<NotificationLogWithRelations, \'fcmMessageId\' | \'fcmToken\'>, schemaOptions: { includeRelations: true, exclude: [ \'fcmMessageId\', \'fcmToken\' ] })
 */
export interface NotificationLogExcludingFcmMessageIdFcmTokenWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: number;
    userId?: number;
    title: string;
    body: string;
    imageUrl?: string;
    data?: object;
    status?: NotificationLogExcludingFcmMessageIdFcmTokenWithRelations.StatusEnum;
    attempts?: number;
    errorMessage?: string;
    sentAt?: string;
    readAt?: string;
    lastAttemptAt?: string;
    notificationType?: NotificationLogExcludingFcmMessageIdFcmTokenWithRelations.NotificationTypeEnum;
    user?: UserExcludingFcmMessageIdFcmTokenWithRelations;
}
export namespace NotificationLogExcludingFcmMessageIdFcmTokenWithRelations {
    export type StatusEnum = 'queued' | 'sent' | 'failed' | 'read';
    export const StatusEnum = {
        Queued: 'queued' as StatusEnum,
        Sent: 'sent' as StatusEnum,
        Failed: 'failed' as StatusEnum,
        Read: 'read' as StatusEnum
    };
    export type NotificationTypeEnum = 'mobile' | 'web' | 'all';
    export const NotificationTypeEnum = {
        Mobile: 'mobile' as NotificationTypeEnum,
        Web: 'web' as NotificationTypeEnum,
        All: 'all' as NotificationTypeEnum
    };
}


